import { NormasTeachingItemType } from "../../Stripe/StripeOrderDTO.ts";
import { PurchasedItemSnapshotDTO } from "./PurchasedItemSnapshotDTO.ts";

export type PurchasedItemNameMaps = {
  productNameById: Record<string, string>;
  bundleNameById: Record<string, string>;
};

export type PurchasedItemRef = {
  id: string;
  type: NormasTeachingItemType | "product" | "bundle";
  snapshot?: PurchasedItemSnapshotDTO;
};

export type ResolvedPurchasedItemName = {
  name: string;
  source: "snapshot" | "lookup" | "id";
};

export const EMPTY_PURCHASED_ITEM_NAME_MAPS: PurchasedItemNameMaps = {
  productNameById: {},
  bundleNameById: {},
};

function nonEmpty(value: string | undefined): string | undefined {
  if (typeof value !== "string") return undefined;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
}

export function resolvePurchasedItemName(
  item: PurchasedItemRef,
  maps: PurchasedItemNameMaps,
): ResolvedPurchasedItemName {
  const isBundle = item.type === NormasTeachingItemType.Bundle;

  const fromSnapshot = isBundle
    ? nonEmpty(item.snapshot?.variantBundleName)
    : nonEmpty(item.snapshot?.variantProductName);

  if (fromSnapshot) return { name: fromSnapshot, source: "snapshot" };

  const fromLookup = isBundle
    ? nonEmpty(maps.bundleNameById[item.id])
    : nonEmpty(maps.productNameById[item.id]);

  if (fromLookup) return { name: fromLookup, source: "lookup" };

  return { name: item.id, source: "id" };
}
